(function () {
    'use strict';

    angular
            .module('gestioneAttiApp')
            .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isEnteUser: isEnteUser,
            isOnlyRoleSectionUser : isOnlyRoleSectionUser,
            isCommissionWithRole: isCommissionWithRole,
            isCitizenUser: isCitizenUser
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities, legislatura) {
            if (!_authenticated || !_identity ) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if ( _identity.authorities && _identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
                if (_identity.legislaturaAuthorities && _identity.legislaturaAuthorities.some(function(legiAuth){
                    if(isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        return legiAuth.authorities && legiAuth.authorities.indexOf(authorities[i]) !== -1;
                    }
                })) {
                    return true;
                }
            }
            return false;
        }

        function hasAuthority(authority, legislatura) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                if( _id.authorities && _id.authorities.indexOf(authority) !== -1) {
                    return true;
                }
                if (_id.legislaturaAuthorities && _id.legislaturaAuthorities.some(function(legiAuth){
                    if(isLegislaturaAuthoritiesToCheck(legiAuth, legislatura)) {
                        return legiAuth.authorities && legiAuth.authorities.indexOf(authority) !== -1;
                    }
                })) {
                    return true;
                }
                return false;
            }, function () {
                return false;
            });
        }

        function isEnteUser(user, legislatura) {
            var authorities = user.authorities;
            var legislaturaAuthorities = user.legislaturaAuthorities;
            if (authorities) {
                for (var i = 0; i < authorities.length; i++) {
                    var auth = authorities[i];
                    if (auth !== 'ROLE_ENTE' && auth !== 'ROLE_USER' && auth !== 'ROLE_TEMPORARYENTE') {
                        return false;
                    }
                }
            }
            if(legislaturaAuthorities) {
                for (var j = 0; j < legislaturaAuthorities.length; j++) {
                    var legislaturaAuth = legislaturaAuthorities[j];
                    if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                        if (legislaturaAuth.authorities) {
                            for (var k = 0; k < legislaturaAuth.authorities.length; k++) {
                                var legiAuth = legislaturaAuth.authorities[k];
                                if (legiAuth !== 'ROLE_ENTE' && legiAuth !== 'ROLE_USER' && legiAuth !== 'ROLE_TEMPORARYENTE') {
                                    return false;
                                }
                            }
                        }
                    }
                }
                return true;
            }
            // FIXME: Se non ha associate authorities nè persistenti, nè di legislatura, è considerato ENTEUSER?
            return false;
        }

        function isOnlyRoleSectionUser(user, legislatura) {

            var authorities = user.authorities;
            var legislaturaAuthorities = user.legislaturaAuthorities;
            if (authorities) {
                for (var i = 0; i < authorities.length; i++) {
                    var auth = authorities[i];
                    if (auth !== 'ROLE_ENTE' && auth !== 'ROLE_USER' && auth !== 'ROLE_TEMPORARYENTE' && auth !== 'ROLE_SECTION') {
                        return false;
                    }
                }
            }
            if(legislaturaAuthorities) {
                for (var j = 0; j < legislaturaAuthorities.length; j++) {
                    var legislaturaAuth = legislaturaAuthorities[j];
                    if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                        if (legislaturaAuth.authorities) {
                            for (var k = 0; k < legislaturaAuth.authorities.length; k++) {
                                var legiAuth = legislaturaAuth.authorities[k];
                                if (legiAuth !== 'ROLE_ENTE' && legiAuth !== 'ROLE_USER' && legiAuth !== 'ROLE_TEMPORARYENTE' && legiAuth !== 'ROLE_SECTION') {
                                    return false;
                                }
                            }
                        }
                    }
                }
                return true;
            }
            return false;
        }

        function isCommissionWithRole(commissionId, commissionRole, legislatura) {

            var commissionAuthorities = ["ROLE_COMMISSIONE"];
            if (hasAnyAuthority(commissionAuthorities, legislatura)) {
                var user = _identity;

                //Nella legislatura l'utente ha ROLE_COMMISSIONE -> Si controlla commissioneRuolo 
                // Gestione pregresso nelle autorities persistenti (non dovrebbe essere più popolato)
                var isCommissionRole = user.commissioneRuolo && user.commissioneRuolo.nome && user.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase();

                if (isCommissionRole) {
                    return true;
                }

                var legislaturaAuthorities = user.legislaturaAuthorities;
                // Controllo commissioneRuolo per authorities di legislatura
                if(legislaturaAuthorities) {
                    for (var i = 0; i < legislaturaAuthorities.length; i++) {
                        var legislaturaAuth = legislaturaAuthorities[i];
                        if(isLegislaturaAuthoritiesToCheck(legislaturaAuth, legislatura)) {
                            if (legislaturaAuth.commissioneRuoloAssociato) {
                                var commRuoloArray = legislaturaAuth.commissioneRuoloAssociato;
                                for (var j = 0; j < commRuoloArray.length; j++) {
                                    var commRuolo = commRuoloArray[j];
                                    if (commissionId) {
                                        if (commRuolo.commissione && commRuolo.commissione.id &&
                                            commRuolo.commissione.id === commissionId &&
                                            commRuolo.commissioneRuolo && commRuolo.commissioneRuolo.nome &&
                                            commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase()){
                                            return true;
                                        }
                                    } else {
                                        // Non è stata specificata la commissione, basta che per una commissione si abbia il ruolo "commissionRole"
                                        if (commRuolo.commissioneRuolo && commRuolo.commissioneRuolo.nome &&
                                            commRuolo.commissioneRuolo.nome.toString().toUpperCase() === commissionRole.toString().toUpperCase()){
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            } else {
                return false;
            }
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                    .then(getAccountThen)
                    .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function isLegislaturaAuthoritiesToCheck(legislaturaAuthority, legislatura) {
            if (!legislatura) {
                return true;
            }
            if (legislaturaAuthority.legislatura && 
                legislaturaAuthority.legislatura.legislatura && 
                legislaturaAuthority.legislatura.legislatura === legislatura) {
                return true;
            } else {
                return false;
            }
        }

        function isCitizenUser(){
            if(_identity && _identity.authorities && _identity.authorities.indexOf("ROLE_ARPA_CITIZEN_USER") !== -1) return true;
            return false;
        }
    }
})();
